import { EditorCardProvider } from '@atlaskit/editor-card-provider';
import { findNodesToPrefetch } from '@atlaskit/node-data-provider';

import {
	NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH,
	NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT,
} from './nodeDataProvidersConstants.ts';

/**
 * Finds and returns smart card nodes from a given document JSON string that should be prefetched.
 *
 * @param docJsonString - The document in JSON string format.
 */
export function findSmartCardNodes(docJsonString: string) {
	if (!docJsonString) {
		return [];
	}

	const doc = JSON.parse(docJsonString);

	const cardProvider = new EditorCardProvider('custom', undefined, 'CONFLUENCE');

	return findNodesToPrefetch(
		doc,
		[
			{
				provider: cardProvider,
				maxNodesToPrefetch: NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH.smartCard,
			},
		],
		NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT,
	)[0].nodes;
}
